import React from "react";
import Logo from "./Logo";

// Full-screen blocking overlay with Dnya logo
export default function LoadingOverlay({ message = "Signing you in Insha'Allah..." }) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(10, 46, 10, 0.92)",
        backdropFilter: "blur(4px)",
        zIndex: 5000,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--dnya-high-1)",
        gap: 18,
      }}
    >
      <div className="dnya-mic-listening" style={{ borderRadius: "50%" }}>
        <Logo size={80} />
      </div>
      <div className="font-dnya" style={{ fontSize: 22, letterSpacing: "0.05em" }}>
        Dnya
      </div>
      <div style={{ fontSize: 14, color: "#CEF0CE", maxWidth: 320, textAlign: "center" }}>
        {message}
      </div>
      <div style={{ width: 180, height: 3, background: "#1a5c1a", borderRadius: 99, overflow: "hidden" }}>
        <div style={{ height: "100%", background: "#CEF0CE", animation: "dnya-bar 1.2s ease-in-out infinite", transformOrigin: "left" }} />
      </div>
    </div>
  );
}
